import { __awaiter, __generator } from "tslib";
import moment from "moment";
import { Platform, Image } from 'react-native';
import React from "react";
import CryptoJS from 'crypto-js';
import servicedByPennymac from './assets/ServicedByPennymac.svg';
import pennymacLogo2025 from './assets/PennymacLogo2025.svg';
import townsgateLogo from './assets/TownsgateLogo.svg';
import EMMPennymacDualLogo300 from './assets/EMM-pennymac-dual-logo-300.svg';
import DeviceInfo from 'react-native-device-info';
export function isHTML(str) {
  return /<\/?[a-z][\s\S]*>/i.test(str);
}
export function versionCompare(v1, v2, options) {
  var lexicographical = options && options.lexicographical,
    zeroExtend = options && options.zeroExtend,
    v1parts = (v1 === null || v1 === void 0 ? void 0 : v1.split('.')) || [],
    v2parts = (v2 === null || v2 === void 0 ? void 0 : v2.split('.')) || [];
  function isValidPart(x) {
    return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
  }
  if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
    return NaN;
  }
  if (zeroExtend) {
    while (v1parts.length < v2parts.length) v1parts.push("0");
    while (v2parts.length < v1parts.length) v2parts.push("0");
  }
  if (!lexicographical) {
    v1parts = v1parts.map(Number);
    v2parts = v2parts.map(Number);
  }
  for (var i = 0; i < v1parts.length; ++i) {
    if (v2parts.length == i) {
      return 1;
    }
    if (v1parts[i] == v2parts[i]) {
      continue;
    } else if (v1parts[i] > v2parts[i]) {
      return 1;
    } else {
      return -1;
    }
  }
  if (v1parts.length != v2parts.length) {
    return -1;
  }
  return 0;
}
export var maskBankInfo = function (value) {
  if (value) {
    var keep = value.slice(-4);
    return "******".concat(keep);
  }
  return "";
};
export var windowObject = typeof window !== 'undefined' && window ? window : {
  location: {
    pathname: "Screen",
    hostname: "Mobile"
  }
};
export var checkForAllNumbers = function (inputtxt, length) {
  var numbers = /^[0-9]+$/;
  if (inputtxt && inputtxt.toString().match(numbers) || inputtxt == '') {
    if (length && inputtxt.length == length) {
      return true;
    } else if (length) {
      return false;
    }
    return true;
  } else {
    return false;
  }
};
export var checkForAllNumbersWithLengthGreater = function (inputtxt, length) {
  var numbers = /^[0-9]+$/;
  if (inputtxt.match(numbers) || inputtxt == '') {
    if (length && inputtxt.length >= length) {
      return true;
    } else if (length) {
      return false;
    }
    return true;
  } else {
    return false;
  }
};
export var checkForAllNumbersWBetweenMinLengthAndMaxLength = function (inputtxt, minlength, maxlength) {
  var numbers = /^[0-9]+$/;
  if (inputtxt.match(numbers) || inputtxt == '') {
    if (minlength && maxlength && inputtxt.length >= minlength && inputtxt.length <= maxlength) {
      return true;
    } else if (minlength && maxlength) {
      return false;
    }
    return true;
  } else {
    return false;
  }
};
export var findUpTag = function (el, attr) {
  while (el.parentNode) {
    el = el.parentNode;
    if (el[attr]) {
      return el;
    }
  }
  return null;
};
export var checkForAllNumbersAndSpecial = function (inputtxt, length) {
  var numbers = length ? new RegExp("^[0-9]".concat(length, "+$")) : /^[0-9]+$/;
  if (inputtxt.match(numbers) || inputtxt == '') {
    return true;
  } else {
    return false;
  }
};
export var checkForAllNumbersAndSpecialZip = function (inputtxt, length) {
  var numbers = /^[0-9-]+$/;
  if (length == '-a-zA-Z') {
    numbers = /^[0-9a-zA-Z\-]+$/;
  }
  if (inputtxt.match(numbers) || inputtxt == '') {
    return true;
  } else {
    return false;
  }
};
export var checkForZip = function (inputtxt) {
  if (!inputtxt.includes("-")) {
    return true;
  }
  var numbers = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
  if (inputtxt.match(numbers)) {
    return true;
  } else {
    return false;
  }
};
export var isValidateZipLengthNew = function (inputtxt) {
  if (inputtxt.includes("-")) {
    return inputtxt.length <= 10;
  } else {
    return inputtxt.length <= 9;
  }
};
export var checkForForeignZip = function (inputtxt) {
  if (inputtxt.includes("-") && (inputtxt.charAt(0) == "-" || inputtxt.charAt(9) == "-")) {
    return false;
  } else {
    return true;
  }
};
export var checkForAllNumbersCurrency = function (inputtxt) {
  var numbers = new RegExp("^[0-9,.]*$");
  if (inputtxt.match(numbers) || inputtxt == '') {
    return true;
  } else {
    return false;
  }
};
export function toCamel(o) {
  var newO, origKey, newKey, value;
  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === "object") {
        value = toCamel(value);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
        value = o[origKey];
        if (value instanceof Array || value !== null && value.constructor === Object) {
          value = toCamel(value);
        }
        newO[newKey] = value;
      }
    }
  }
  return newO;
}
export function checkIfStringHasSpecialChar(_string) {
  for (var i = 0; i < _string.length; i++) {
    if (_string.charCodeAt(i) <= 31 || _string.charCodeAt(i) > 126) {
      return false;
    }
  }
  return true;
}
export var paymentTypes = {
  0: "Unknown",
  201296: "Trial Payment",
  201297: "Principal Reduction",
  201298: "Monthly Payment",
  201299: "Additional Amounts",
  1000145: "Forbearance",
  201309: "AutoPay Monthly",
  201311: "Monthly Payment",
  1000146: "Increased/ Decreased"
};
export var paymentsource = {
  0: "Web",
  1: "Telephone",
  2: "Unknown",
  3: "Customer Service Rep",
  4: "AutoPay Monthly",
  5: "AutoPay BiWeekly",
  6: "Mobile"
};
export var accountype = {
  0: "Unknown",
  201286: "Checking",
  201287: "Saving",
  201288: "DebitCard"
};
export var paystatus = {
  0: "Processing",
  201290: "Processing",
  201291: "Scheduled",
  201292: "Complete",
  201293: "Cancelled",
  201294: "Cancelling",
  201295: "Failed",
  1000008: "Processing",
  301296: "Pending",
  201289: "ProcessingPayment"
};
export var RuleId = {
  Default: "Default",
  Delinquent: "Delinquent",
  Suspended_Forbearance: "Suspended_Forbearance",
  Increased_Payment_Plan: "Increased_Payment_Plan",
  Reduced_Payment_Plan: "Reduced_Payment_Plan",
  Bau_Old: "BAU-Old",
  Delinquent_Greater_than_Six_Payments_Due: "Delinquent_Greater_than_Six_Payments_Due",
  Bau_Normal: "BAU-Normal"
};
export var defaulPaymentType = {
  Invalid: 0,
  PIT: 1,
  PITI: 2
};
export var defaulPaymentTypeStr = {
  PIT: "PIT",
  PITI: "PITI"
};
export function getPayStatusTranslations(translations, status) {
  var _a;
  return (_a = translations === null || translations === void 0 ? void 0 : translations["PayStatus".concat(paystatus[status])]) !== null && _a !== void 0 ? _a : status;
}
export var isValidatePhoneNumberLength = function (data) {
  var regdata = data.replace(/[^\w]/gi, '');
  return (regdata === null || regdata === void 0 ? void 0 : regdata.length) <= 10;
};
export var isValidateZipLength = function (data) {
  var regdata = data.replace(/[^\w]/gi, '');
  return (regdata === null || regdata === void 0 ? void 0 : regdata.length) <= 10;
};
export var currencyFormatter = function (locals, style, currency, number) {
  return new Intl.NumberFormat(locals, {
    style: style,
    currency: currency,
    minimumFractionDigits: 2
  }).format(number);
};
export var currencyFormatterWithoutSign = function (locals, style, currency, number) {
  return new Intl.NumberFormat(locals, {
    style: style,
    currency: currency,
    minimumFractionDigits: 2
  }).format(Math.abs(number));
};
export var percentFormatter = function (locals, style, number, digits) {
  if (digits === void 0) {
    digits = 3;
  }
  return new Intl.NumberFormat(locals, {
    style: style,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(number);
};
export var loanTerm = function (d1, d2) {
  var months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
};
export var addMonths = function (date, months) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + +months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
};
export var getActiveFeatures = function (features, feature, whitelisted) {
  if (features && features.find(function (s) {
    return s.feature == feature;
  }) && features.find(function (s) {
    return s.feature == feature && s.toggled == true;
  })) {
    return true;
  }
  return whitelisted || false;
};
export var getActiveFeaturesWithExceptions = function (layout, feature, exception) {
  var _a;
  if (!layout) return false;
  var ok = layout.features.find(function (s) {
    return s.feature == feature && s.toggled == true;
  });
  if (ok && ((_a = ok.description) === null || _a === void 0 ? void 0 : _a.includes(exception))) {
    return true;
  }
  return layout.whitelisted || false;
};
export var closingLogOut = function () {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch("/oauth/logout?logout=".concat(true))];
        case 1:
          _a.sent();
          return [2 /*return*/];
      }
    });
  });
};
export var showTakeActionDeterminStatus = function (status, stat) {
  var _a, _b;
  var logic = function (_status) {
    var _a;
    return "default,bankruptcy,completedtwo".toLowerCase().indexOf((_a = _status === null || _status === void 0 ? void 0 : _status.processStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase()) > -1;
  };
  if ((stat === null || stat === void 0 ? void 0 : stat.statusTypeIsInTrial) || ((_a = paymentStatus(status, "current", [])) === null || _a === void 0 ? void 0 : _a.hasStatus) || ((_b = genericStatusCheck(status, "completeOne", ["servicereleased"])) === null || _b === void 0 ? void 0 : _b.hasSubStatus) || logic(status)) {
    return true;
  }
  return false;
};
export var socialMediaDeterminStatus = function (status, modifcation) {
  var _a, _b, _c;
  var logic = function (_status) {
    var _a;
    return "default,bankruptcy,completedtwo".toLowerCase().indexOf((_a = _status === null || _status === void 0 ? void 0 : _status.processStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase()) > -1;
  };
  if (((_a = paymentStatus(status, "delinquent", ["2PaymentsPastDue"])) === null || _a === void 0 ? void 0 : _a.hasSubStatus) || (modifcation === null || modifcation === void 0 ? void 0 : modifcation.statusTypeIsInTrial) || ((_b = paymentStatus(status, "current", [])) === null || _b === void 0 ? void 0 : _b.hasStatus) || ((_c = genericStatusCheck(status, "completeOne", ["servicereleased"])) === null || _c === void 0 ? void 0 : _c.hasSubStatus) || logic(status)) {
    return true;
  }
  return false;
};
export var loanIsForbearance = function (status) {
  var _a, _b;
  return {
    isForbearance: ((_a = status === null || status === void 0 ? void 0 : status.processStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == "lossmitigation",
    forbearanceStatus: (_b = status === null || status === void 0 ? void 0 : status.processPhaseStatus) === null || _b === void 0 ? void 0 : _b.toLowerCase()
  };
};
export var loanCompletedOne = function (status) {
  var _a, _b;
  return {
    isCompletedOne: "completedtwo,completedone".toLowerCase().indexOf((_a = status === null || status === void 0 ? void 0 : status.processStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase()) > -1,
    completedOneStatus: (_b = status === null || status === void 0 ? void 0 : status.processPhaseStatus) === null || _b === void 0 ? void 0 : _b.toLowerCase()
  };
};
export var phazOne = function (status) {
  var _a, _b;
  var logic = function (_status) {
    var _a;
    return "default,foreclosure,completedtwo,completedone,delinquentliquidation,hhf,shortSale,deedinlieu".toLowerCase().indexOf((_a = _status === null || _status === void 0 ? void 0 : _status.processStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase()) > -1;
  };
  if (ammountPaymentPastDue(status, 3, true, false) || genericStatusCheck(status, "completeone", ["servicereleased"]).hasSubStatus || ((_a = loanIsForbearance(status)) === null || _a === void 0 ? void 0 : _a.isForbearance) || logic(status)) {
    if ((_b = genericStatusCheck(status, "bankruptcy", ["bankruptcyChapter12", "BankruptcyChapter12Discharged", "bankruptcyChapter7", "BankruptcyChapter7Discharged"])) === null || _b === void 0 ? void 0 : _b.hasSubStatus) {
      return false;
    }
    return true;
  }
  return false;
};
export var isValidatePhoneNumber = function (input_str) {
  var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
  return re.test(input_str);
};
export var isEmptyOrSpaces = function (str) {
  return str === null || str.match(/^ *$/) !== null;
};
export var checkIfHasPreference = function (userPreferences, preference) {
  if (userPreferences != null) {
    return userPreferences.find(function (d) {
      return d.preferenceTypeLId == preference;
    }) != null;
  }
  return false;
};
export var userHasPreference = function (userPreferences, loanPreferenceTypeLID, loanPreferenceValueLID, eventNotificationPreference) {
  var isPreferenceSelected = false;
  if (userPreferences != null) {
    if (parseInt(loanPreferenceTypeLID) == 300103) {
      // for the payment reminder preference
      isPreferenceSelected = userPreferences.find(function (x) {
        return x.prefenceValueTypeId == loanPreferenceValueLID && parseInt(x.prefenceTypeId) == parseInt(loanPreferenceTypeLID) && parseInt(x.eventNotificationPreference) == parseInt(eventNotificationPreference);
      }) != null;
    } else {
      isPreferenceSelected = userPreferences.find(function (x) {
        /*x.prefenceValueTypeId == loanPreferenceValueLID &&*/return parseInt(x.prefenceTypeId) == parseInt(loanPreferenceTypeLID) && parseInt(x.eventNotificationPreference) == parseInt(eventNotificationPreference);
      }) != null;
    }
  }
  return isPreferenceSelected;
};
export var getActiveFeaturesDescription = function (features, feature) {
  if (features && features.find(function (s) {
    return s.feature == feature;
  })) {
    return features.find(function (s) {
      return s.feature == feature;
    }).description;
  }
  return "";
};
export var setCookie = function (cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;secure=true;samesite=none";
};
export var getCookie = function (cname) {
  try {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  } catch (err) {}
};
export var modificationOrDelinquent = function (status, modification) {
  var _a;
  if (modification) {
    return true;
  }
  if ((_a = paymentStatus(status, "delinquent", [])) === null || _a === void 0 ? void 0 : _a.hasStatus) {
    return true;
  }
  return false;
};
export var genericStatusCheck = function (statuses, status, substatuses) {
  var _a;
  return {
    hasStatus: status.toLowerCase().includes((_a = statuses === null || statuses === void 0 ? void 0 : statuses.processStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase()),
    hasSubStatus: substatuses.find(function (s) {
      var _a;
      return s.toLowerCase() == ((_a = statuses === null || statuses === void 0 ? void 0 : statuses.processPhaseStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase());
    })
  };
};
export var paymentStatus = function (statuses, status, substatuses) {
  var _a, _b;
  if ("normalservicing".includes((_a = statuses === null || statuses === void 0 ? void 0 : statuses.processStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase())) {
    return {
      hasStatus: status.toLowerCase().includes((_b = statuses === null || statuses === void 0 ? void 0 : statuses.paymentStatus) === null || _b === void 0 ? void 0 : _b.toLowerCase()),
      hasSubStatus: substatuses.find(function (s) {
        var _a;
        return s.toLowerCase() == ((_a = statuses === null || statuses === void 0 ? void 0 : statuses.paymentSubStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase());
      })
    };
  } else {
    return null;
  }
};
export var ammountPaymentAhead = function (statuses, numPayment) {
  var _a;
  for (var d = numPayment; d <= 100; d++) {
    if ((_a = paymentStatus(statuses, "paidahead", ["paidAhead".concat(d, "Payments")])) === null || _a === void 0 ? void 0 : _a.hasSubStatus) {
      return true;
    }
  }
  return false;
};
export var ammountPaymentPastDue = function (statuses, numPayment, greater, lessthan) {
  var _a, _b, _c, _d, _e;
  if (greater === void 0) {
    greater = false;
  }
  if (lessthan === void 0) {
    lessthan = false;
  }
  if ((_a = paymentStatus(statuses, "delinquent", [])) === null || _a === void 0 ? void 0 : _a.hasStatus) {
    if (lessthan) {
      for (var d = numPayment; d >= 0; d--) {
        if ((_b = paymentStatus(statuses, "delinquent", ["".concat(d, "PaymentsPastDue")])) === null || _b === void 0 ? void 0 : _b.hasSubStatus) {
          return true;
        }
      }
    }
    if (greater) {
      if (numPayment >= 7 && ((_c = paymentStatus(statuses, "delinquent", ["7PaymentsPastDue"])) === null || _c === void 0 ? void 0 : _c.hasSubStatus)) {
        return true;
      }
      for (var d = numPayment; d <= 100; d++) {
        if ((_d = paymentStatus(statuses, "delinquent", ["".concat(d, "PaymentsPastDue")])) === null || _d === void 0 ? void 0 : _d.hasSubStatus) {
          return true;
        }
      }
    }
    for (var i = 1; i <= numPayment; i++) {
      if ((_e = paymentStatus(statuses, "delinquent", ["".concat(d, "PaymentsPastDue")])) === null || _e === void 0 ? void 0 : _e.hasSubStatus) {
        return true;
      }
    }
    return false;
  } else {
    return false;
  }
};
export var checkPasswordValidation = function (nPassword) {
  var newPWFormat = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/;
  if (nPassword.match(newPWFormat)) {
    return true;
  } else {
    return false;
  }
};
export var endsWith = function (str, suffix) {
  return str.toLowerCase().indexOf(suffix.toLowerCase(), str.length - suffix.length) !== -1;
};
export var calulateFees = function (obj) {};
export var checkForAlphanumericAndSpace = function (inputtxt) {
  var alphanumericAndSpace = new RegExp("^[A-Za-z0-9 ]+$");
  if (inputtxt.match(alphanumericAndSpace) || inputtxt == '') {
    return true;
  } else {
    return false;
  }
};
export function isSameDay(currentMessage, diffMessage) {
  if (currentMessage === void 0) {
    currentMessage = {};
  }
  if (diffMessage === void 0) {
    diffMessage = {};
  }
  var currentCreatedAt = moment(currentMessage.createdAt);
  var diffCreatedAt = moment(diffMessage.createdAt);
  if (!currentCreatedAt.isValid() || !diffCreatedAt.isValid()) {
    return false;
  }
  return currentCreatedAt.isSame(diffCreatedAt, "day");
}
var isIPhone = Platform.OS === 'ios';
var isAndroid = !isIPhone;
var isIPhoneX = isIPhone;
var ifAndroid = function (androidArg, regularArg) {
  if (regularArg === void 0) {
    regularArg = null;
  }
  return isAndroid ? androidArg : regularArg;
};
var ifIphone = function (iPhoneArg, regularArg) {
  if (regularArg === void 0) {
    regularArg = null;
  }
  return isIPhone ? iPhoneArg : regularArg;
};
var ifIphoneX = function (iPhoneXArg, regularArg) {
  if (regularArg === void 0) {
    regularArg = null;
  }
  return isIPhoneX ? iPhoneXArg : regularArg;
};
var getBiotech = function () {
  return ifAndroid('biometricSettingsTitleAndroidTouch', ifIphoneX('biometricSettingsTitleIOSFace', 'biometricSettingsTitleIOSTouch'));
};
export var platformUtils = {
  // deviceName,
  isIPhone: isIPhone,
  isIPhoneX: isIPhoneX,
  isAndroid: isAndroid,
  getBiotech: getBiotech,
  ifAndroid: ifAndroid,
  ifIphone: ifIphone,
  ifIphoneX: ifIphoneX
};
export var formatAddress = function (address) {
  if (!address) return '';
  var address1 = address.address1,
    address2 = address.address2,
    unit = address.unit,
    city = address.city,
    state = address.state,
    zip = address.zip;
  var resp = [];
  if (!address1 || !address1.trim()) return "N/A";
  resp.push(address1);
  if (address2) resp.push(address2);
  if (unit) resp.push("# ".concat(unit));
  resp.push("".concat(city, ", ").concat(state, " ").concat(zip));
  return resp.join("\n");
  // return `${address1}\n${city}, ${state} ${zip}`;
};
export var formatDollar = function (val) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(val);
};
export function isSameUser(currentMessage, diffMessage) {
  if (currentMessage === void 0) {
    currentMessage = {};
  }
  if (diffMessage === void 0) {
    diffMessage = {};
  }
  return !!(diffMessage.user && currentMessage.user && diffMessage.user._id === currentMessage.user._id);
}
export function useEventListener(eventName, handler, element) {
  if (element === void 0) {
    element = window;
  }
  // Create a ref that stores handler
  var savedHandler = React.useRef();
  // Update ref.current value if handler changes.
  // This allows our effect below to always get latest handler ...
  // ... without us needing to pass it in effect deps array ...
  // ... and potentially cause effect to re-run every render.
  React.useEffect(function () {
    savedHandler.current = handler;
  }, [handler]);
  React.useEffect(function () {
    // Make sure element supports addEventListener
    // On
    var isSupported = element && element.addEventListener;
    //alert(isSupported);
    if (!isSupported) return;
    // Create event listener that calls handler function stored in ref
    var eventListener = function (event) {
      return savedHandler.current(event);
    };
    // Add event listener
    element.addEventListener(eventName, eventListener);
    // Remove event listener on cleanup
    return function () {
      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element] // Re-run if eventName or element changes
  );
}
///any part visible web --
export function elementInViewport2(el) {
  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;
  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }
  console.log("".concat(top, " Two"), "".concat(el, " ").concat(left));
  return top < window.pageYOffset + window.innerHeight && left < window.pageXOffset + window.innerWidth && top + height > window.pageYOffset && left + width > window.pageXOffset;
}
//whole element visible
export function elementInViewport(el) {
  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;
  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }
  console.log("".concat(top, " One"), "".concat(el, " ").concat(left));
  return top >= window.pageYOffset && left >= window.pageXOffset && top + height <= window.pageYOffset + window.innerHeight && left + width <= window.pageXOffset + window.innerWidth;
}
export var amountNullCheck = function (value) {
  if (value && Math.abs(value) > 0.0) {
    return currencyFormatter('en-US', 'currency', 'USD', Math.abs(value));
  } else {
    return "N/A";
  }
};
export var isWeb = function () {
  return Platform.OS === 'web';
};
export var isCobrandedHost = function () {
  return isWeb() && window.location.hostname.includes("customers-subservicing");
};
export var isPrivateLabelHost = function () {
  return isWeb() ? window.location.hostname.includes("townsgateservicing.com") : DeviceInfo.getBundleId().includes("com.townsgate");
};
export var isPennymacHost = function () {
  return isWeb() ? window.location.hostname.includes("pennymac.com") && !isCobrandedHost() : DeviceInfo.getBundleId().includes("com.pennymac");
};
export var getLogoUrl = function (orgLogoFilePath, msrCode, servicingContractTypeId) {
  var PennymaclogoUrl = isWeb() ? pennymacLogo2025 : "Pennymaclogo2025";
  var SeviciedbyPennymadlogoUrl = isWeb() ? servicedByPennymac : "servicedByPennymac";
  var logoUrl = servicingContractTypeId === 1 ? SeviciedbyPennymadlogoUrl : PennymaclogoUrl;
  if (isPrivateLabelHost()) {
    logoUrl = townsgateLogo;
  }
  if (isCobrandedHost()) {
    logoUrl = servicedByPennymac;
  }
  // NOTE: LEAVING HERE WE MAY RE-VISIT THIS.
  // if (orgLogoFilePath) {
  //   logoUrl = orgLogoFilePath
  // }
  switch (msrCode) {
    case "100":
      logoUrl = Platform.OS === 'web' ? EMMPennymacDualLogo300 : "emmPennymacDualLogo300";
      break;
  }
  return logoUrl;
};
export var isPennymac = function (servicingContractTypeId) {
  return !servicingContractTypeId && isPennymacHost() || servicingContractTypeId === 2;
};
export var isCobranded = function (servicingContractTypeId) {
  return !servicingContractTypeId && isCobrandedHost() || servicingContractTypeId === 1;
};
export var isPrivateLabel = function (servicingContractTypeId) {
  return !servicingContractTypeId && isPrivateLabelHost() || servicingContractTypeId === 3;
};
export var isSubServicingLoan = function (layout) {
  return !layout.isPennymac;
};
export function testID(id) {
  return Platform.OS === 'android' ? {
    accessible: true,
    accessibilityLabel: id
  } : {
    testID: id
  };
}
export var isTaxOptionsLoan = function (layout) {
  var _a, _b, _c;
  var loanPropertyRegion = (_a = layout.currentLoan) === null || _a === void 0 ? void 0 : _a.propertyRegion;
  var escrowCheck = ((_b = layout.currentLoan) === null || _b === void 0 ? void 0 : _b.loanActiveFlag) && ((_c = layout.currentLoan) === null || _c === void 0 ? void 0 : _c.escrowFlag);
  if (loanPropertyRegion === 'WI') {
    return escrowCheck;
  } else if (loanPropertyRegion === 'TX') {
    return escrowCheck && layout.taxOptionAvailable;
  }
  return false;
};
export var checkTaxOptionFeatureToggle = function (layout) {
  var _a, _b;
  var hasTaxOptionsEnabled = getActiveFeatures(layout === null || layout === void 0 ? void 0 : layout.features, "View_TaxOptions", layout === null || layout === void 0 ? void 0 : layout.whitelisted);
  var taxOptionsFeatureToggle = (_a = layout === null || layout === void 0 ? void 0 : layout.features) === null || _a === void 0 ? void 0 : _a.find(function (a) {
    return a.feature == "View_TaxOptions";
  });
  if (hasTaxOptionsEnabled && taxOptionsFeatureToggle) {
    try {
      var taxOptionDescription = JSON.parse(taxOptionsFeatureToggle === null || taxOptionsFeatureToggle === void 0 ? void 0 : taxOptionsFeatureToggle.description);
      var mailedDate = taxOptionDescription === null || taxOptionDescription === void 0 ? void 0 : taxOptionDescription.mailed_date;
      var loanAddedDate = (_b = layout.currentLoan) === null || _b === void 0 ? void 0 : _b.loanAddedDate;
      var mDate = moment(mailedDate, "MM/DD/YYYY");
      var lDate = moment(loanAddedDate, "YYYY-MM-DD");
      hasTaxOptionsEnabled = lDate < mDate;
    } catch (error) {}
  }
  return hasTaxOptionsEnabled;
};
var fixedIV = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');
export function decryptBankAccountNumber(plainText) {
  if (!plainText) {
    return '';
  }
  var key = CryptoJS.enc.Utf8.parse('AAECAwQFBgcICQoLDA0ODw==');
  var encrypted = CryptoJS.enc.Base64.parse(plainText);
  var decrypted = CryptoJS.AES.decrypt({
    ciphertext: encrypted
  }, key, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: fixedIV
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}
export function encryptBankAccountNumber(plainText) {
  if (!plainText) {
    return '';
  }
  var key = CryptoJS.enc.Utf8.parse('AAECAwQFBgcICQoLDA0ODw==');
  var encrypted = CryptoJS.AES.encrypt(plainText, key, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: fixedIV
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}